import { Card, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import * as APITypes from "~/API";

const BuildingItemCard = (buildingItem: APITypes.Building) => {
  return (
    <Card bordered style={{ display: "flex" }}>
      <div>Image</div>
      <Space direction="vertical" size={"small"}>
        <Typography.Title level={5}>
          <Link to={`/building${buildingItem.id}`}>{buildingItem.name}</Link>
        </Typography.Title>
        <Typography.Paragraph type="secondary">
          <ul>
            <li>Building attributes</li>
          </ul>
        </Typography.Paragraph>
      </Space>
    </Card>
  );
};

export default BuildingItemCard;
